<template>
  <sidenav :orientation="orientation" :class="curClasses">

    <!-- Inner -->
    <div class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }">

      <sidenav-router-link icon="ion ion-ios-contact" to="/" :exact="true">Inicio</sidenav-router-link>
      <sidenav-router-link icon="ion ion-md-desktop" to="/page-2" :exact="true">Page 2</sidenav-router-link>
      <sidenav-router-link icon="ion ion-md-people" to="/users" :exact="true">Usuarios</sidenav-router-link>
      <sidenav-router-link icon="ion ion-md-paw" to="/canines" :exact="true">Caninas</sidenav-router-link>
      <sidenav-router-link icon="ion ion-md-albums" to="/expos" :exact="true">Exposiciones</sidenav-router-link>
      <sidenav-router-link icon="ion ion-md-albums" to="/inscriptions" :exact="true">Inscripciones</sidenav-router-link>

       <sidenav-menu icon="ion ion-md-cube" :active="isMenuActive('/configuracion')" :open="isMenuOpen('/configuracion')">
        <template slot="link-text">Configuración</template>
        <sidenav-router-link to="/config" :exact="true">Configuración General</sidenav-router-link>
        <sidenav-router-link to="/config/prices" :exact="true">Tabla de Precios</sidenav-router-link>
        <sidenav-router-link to="/config/books" :exact="true">Tipos de Libros</sidenav-router-link>
        <sidenav-router-link to="/config/races" :exact="true">Gestión de Razas</sidenav-router-link>
        <sidenav-router-link to="/config/countries" :exact="true">Países</sidenav-router-link>
      </sidenav-menu>
    </div>
  </sidenav>
</template>

<script>
import { Sidenav, SidenavLink, SidenavRouterLink, SidenavMenu, SidenavHeader, SidenavBlock, SidenavDivider } from '@/vendor/libs/sidenav'

export default {
  name: 'app-layout-sidenav',
  components: {
    Sidenav,
    SidenavLink,
    SidenavRouterLink,
    SidenavMenu,
    SidenavHeader,
    SidenavBlock,
    SidenavDivider
  },

  props: {
    orientation: {
      type: String,
      default: 'vertical'
    }
  },

  computed: {
    curClasses () {
      let bg = this.layoutSidenavBg

      if (this.orientation === 'horizontal' && (bg.indexOf(' sidenav-dark') !== -1 || bg.indexOf(' sidenav-light') !== -1)) {
        bg = bg
          .replace(' sidenav-dark', '')
          .replace(' sidenav-light', '')
          .replace('-darker', '')
          .replace('-dark', '')
      }

      return `bg-${bg} ` + (
        this.orientation !== 'horizontal'
          ? 'layout-sidenav'
          : 'layout-sidenav-horizontal container-p-x flex-grow-0'
      )
    }
  },

  methods: {
    isMenuActive (url) {
      return this.$route.path.indexOf(url) === 0
    },

    isMenuOpen (url) {
      return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
    },

    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    }
  }
}
</script>
